import { Chip } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import useColors from "../../api/hooks/useColors";
import TooltipWrapper from "../TooltipWrapper";
import POCTooltip from "./POCTooltip";

const POCTag = ({ pocLimits }) => {
  const colors = useColors();

  return (
    <TooltipWrapper
      placement="bottom"
      width="150px"
      padding="8px"
      style={{
        zIndex: zIndex.tooltip,
        borderTop: "2px solid " + colors.primary_main,
        borderRadius: "6px",
      }}
      content={<POCTooltip pocLimits={pocLimits} />}
    >
      <Chip
        label="TRIAL"
        variant="outlined"
        sx={{
          color: colors.primary_main,
          borderColor: colors.primary_main,
          borderRadius: "8px",
          lineHeight: "16px",
          height: "16px",
        }}
      />
    </TooltipWrapper>
  );
};

export default POCTag;
